/**
 * Lazy-load cart drawer HTML/CSS/JS on demand
 * This reduces initial page payload by loading cart drawer only when needed
 */
(function() {
  'use strict';

  let cartDrawerLoaded = false;
  let cartDrawerLoading = false;

  // Cart drawer styles ship in theme.css (loaded on every page), so there is no
  // separate cart-drawer.css to inject. (The old loader requested a non-existent
  // file and 404'd on every drawer open.)

  /**
   * Load cart drawer HTML via Shopify section rendering API
   */
  function loadCartDrawerHTML() {
    const sectionId = 'cart-drawer-lazy';
    const url = `${window.theme?.routes?.root || '/'}?section_id=${sectionId}`;
    
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartDrawerHTML = doc.querySelector('#cart-drawer');
        
        if (cartDrawerHTML) {
          const placeholder = document.querySelector('#cart-drawer[data-cart-drawer-lazy]');
          if (placeholder && placeholder.parentNode) {
            // Replace placeholder with actual cart drawer HTML
            placeholder.parentNode.replaceChild(cartDrawerHTML, placeholder);
            return true;
          }
        }
        return false;
      })
      .catch(error => {
        console.error('Error loading cart drawer:', error);
        // Fallback: try to render inline if available
        return false;
      });
  }

  /**
   * Initialize cart drawer lazy loading
   */
  function initCartDrawerLazyLoad() {
    const cartToggles = document.querySelectorAll('[data-cart-drawer-toggle]');
    
    if (!cartToggles.length) {
      return;
    }

    cartToggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        // Only intercept if cart drawer hasn't been loaded yet
        if (!cartDrawerLoaded && !cartDrawerLoading) {
          e.preventDefault();
          e.stopPropagation();
          
          cartDrawerLoading = true;

          // Load HTML (cart drawer CSS is already in theme.css)
          loadCartDrawerHTML().then(success => {
            cartDrawerLoading = false;
            if (success) {
              cartDrawerLoaded = true;
              
              // Dispatch event for theme.js to initialize cart drawer
              document.dispatchEvent(new CustomEvent('cart-drawer:loaded', { bubbles: true }));
              
              // Update CartDrawer reference and open the drawer
              setTimeout(() => {
                if (window.cart) {
                  // Point the CartDrawer instance at the newly injected element
                  const newCartDrawerEl = document.querySelector('[data-cart-drawer]');
                  if (newCartDrawerEl) {
                    window.cart.cartDrawer = newCartDrawerEl;
                    window.cart.cart = newCartDrawerEl;
                  }
                  window.cart.renderCartDrawer(true);
                } else {
                  // Fallback: trigger click again to open drawer
                  toggle.click();
                }
              }, 100);
            } else {
              // Fallback: redirect to cart page
              window.location.href = '/cart';
            }
          });
        }
      }, { once: false, passive: false });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerLazyLoad);
  } else {
    initCartDrawerLazyLoad();
  }
})();

